/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {RemoveManagerRelationResponse} from '../models/RemoveManagerRelationResponse';
import type {RemoveManagerRequest} from '../models/RemoveManagerRequest';

export interface GetBulkResult$Request {
    id: string;
}

export interface GetBulkResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBulkResultRequest = createAction<PayloadData<void, GetBulkResult$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__GET_BULK_RESULT__REQUEST');
export const getBulkResultSuccess = createAction<PayloadData<RemoveManagerRelationResponse, GetBulkResult$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__GET_BULK_RESULT__SUCCESS');
export const getBulkResultFailure = createAction<PayloadData<Error, GetBulkResult$Request, true>>('ACCOUNT_MANAGER_REMOVE_BULK__GET_BULK_RESULT__FAILURE');

export const getBulkResultActions = [
    getBulkResultRequest,
    getBulkResultSuccess,
    getBulkResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBulkResult = (meta: GetBulkResult$Request, config?: GetBulkResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getBulkResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/remove-account-manager-relations`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetRemoveRelationsProgress$Request {
    id: string;
}

export interface GetRemoveRelationsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRemoveRelationsProgressRequest = createAction<PayloadData<void, GetRemoveRelationsProgress$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__GET_REMOVE_RELATIONS_PROGRESS__REQUEST');
export const getRemoveRelationsProgressSuccess = createAction<PayloadData<BulkProgress, GetRemoveRelationsProgress$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__GET_REMOVE_RELATIONS_PROGRESS__SUCCESS');
export const getRemoveRelationsProgressFailure = createAction<PayloadData<Error, GetRemoveRelationsProgress$Request, true>>('ACCOUNT_MANAGER_REMOVE_BULK__GET_REMOVE_RELATIONS_PROGRESS__FAILURE');

export const getRemoveRelationsProgressActions = [
    getRemoveRelationsProgressRequest,
    getRemoveRelationsProgressSuccess,
    getRemoveRelationsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRemoveRelationsProgress = (meta: GetRemoveRelationsProgress$Request, config?: GetRemoveRelationsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getRemoveRelationsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/remove-account-manager-relations/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveAccountManagerBulk$Request {
    reason?: string;
    removeManagerRequest?: RemoveManagerRequest;
}

export interface RemoveAccountManagerBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeAccountManagerBulkRequest = createAction<PayloadData<void, RemoveAccountManagerBulk$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__REMOVE_ACCOUNT_MANAGER_BULK__REQUEST');
export const removeAccountManagerBulkSuccess = createAction<PayloadData<string, RemoveAccountManagerBulk$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__REMOVE_ACCOUNT_MANAGER_BULK__SUCCESS');
export const removeAccountManagerBulkFailure = createAction<PayloadData<Error, RemoveAccountManagerBulk$Request, true>>('ACCOUNT_MANAGER_REMOVE_BULK__REMOVE_ACCOUNT_MANAGER_BULK__FAILURE');

export const removeAccountManagerBulkActions = [
    removeAccountManagerBulkRequest,
    removeAccountManagerBulkSuccess,
    removeAccountManagerBulkFailure
] as const;

/**
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {RemoveManagerRequest} [meta.removeManagerRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeAccountManagerBulk = (meta: RemoveAccountManagerBulk$Request, config?: RemoveAccountManagerBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: removeAccountManagerBulkActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/accounts/remove-account-manager-relations`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.removeManagerRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkAction$Request {
    id: string;
}

export interface StopBulkAction$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkActionRequest = createAction<PayloadData<void, StopBulkAction$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__STOP_BULK_ACTION__REQUEST');
export const stopBulkActionSuccess = createAction<PayloadData<void, StopBulkAction$Request>>('ACCOUNT_MANAGER_REMOVE_BULK__STOP_BULK_ACTION__SUCCESS');
export const stopBulkActionFailure = createAction<PayloadData<Error, StopBulkAction$Request, true>>('ACCOUNT_MANAGER_REMOVE_BULK__STOP_BULK_ACTION__FAILURE');

export const stopBulkActionActions = [
    stopBulkActionRequest,
    stopBulkActionSuccess,
    stopBulkActionFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkAction = (meta: StopBulkAction$Request, config?: StopBulkAction$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkActionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/accounts/remove-account-manager-relations`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

